import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import WorkshopProduction from '@/roc/effects/Production/WorkshopProduction';
import {getIcon, WorkshopProductionGroup} from '@/roc/building/workshop/WorkshopOutput';
import EraType from '@/roc/era/EraType';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const SpiceMerchant = {
  id: "17",
  name: "Spice Merchant",
  width: 4,
  height: 3,
  type: BuildingType.WORKSHOP_2,
  era: "byzantineEra",
  icon: getIcon(WorkshopProductionGroup.SpiceMerchant),
  minLevel: 1,
  maxLevel: BuildingMaxLevel.WORKSHOP_2,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Workshops/Spice_Merchant',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: null,
    minoanEra: null,
    classicGreece: null,
    earlyRome: null,
    romanEmpire: null,
    byzantineEra: 3,
    ageOfTheFranks: 4,
    feudalAge: 4,
    iberianEra: 4,
    kingdomOfSicily: 4,
    highMiddleAges: 4,
    earlyGothicEra: 4,
    lateGothicEra: 4,
  },
  effects: Effects.create([
    new WorkshopProduction(WorkshopProductionGroup.SpiceMerchant, EraType.byzantineEra),
    new WorkshopProduction(WorkshopProductionGroup.SpiceMerchant, EraType.ageOfTheFranks),
    new WorkshopProduction(WorkshopProductionGroup.SpiceMerchant, EraType.feudalAge),
    new WorkshopProduction(WorkshopProductionGroup.SpiceMerchant, EraType.iberianEra),
    new WorkshopProduction(WorkshopProductionGroup.SpiceMerchant, EraType.kingdomOfSicily),
    new WorkshopProduction(WorkshopProductionGroup.SpiceMerchant, EraType.highMiddleAges),
    new Happiness({
      stoneAge: null,
      bronzeAge: null,
      minoanEra: null,
      classicGreece: null,
      earlyRome: null,
      romanEmpire: null,
      byzantineEra: [420, 840, 1680],
      ageOfTheFranks: [510, 1020, 2040],
      feudalAge: [600, 1200, 2400],
      iberianEra: [720, 1440, 2880],
      kingdomOfSicily: [870, 1740, 3480],
      highMiddleAges: [1050, 2100, 4200],
      earlyGothicEra: null,
      lateGothicEra: null,
    }),
  ]),
};

export default SpiceMerchant;
